import { IOperator } from './interfaces';
import { IError, clone, EComponentTypes, IDecision } from './';
import { getOperatorOptions, getOperator } from './io';
import { Promise } from 'es6-promise';
import store from '../store/store';
import types from '../store/types';

export class ConditionsHelper {

	public static loadOperatorOptions(): Promise<IOperator[]> {

		var promise = new Promise((resolve, reject) => {
			
			getOperatorOptions()
				.then(operatorNames => {

					let requests: Promise<IOperator>[] = operatorNames.map(getOperator);

					Promise
						.all(requests)
						.then((operators: IOperator[]) => {

							// Store operators
							store.dispatch({
								type: types.SET_OPERATORS,
								operators: operators
							});

							resolve(operators);
						})
						.catch(reject);
				})
				.catch((error) => {
					reject(error);
				});

		});

		return promise;
	}

	public static getDefaultDecisionComponent = (templates: any): IDecision => {

		let decisionTemplate = clone(templates[EComponentTypes.decision].Decision);
		return decisionTemplate;
	}

}


// WEBPACK FOOTER //
// ./source/ts/helpers/conditions.ts